module.exports = __webpack_public_path__ + "img/heaven_image_1.efc76107.jpeg";